import React from "react";

import { ICustomSubscriptionParams } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IFormButtons, IAPIError } from "shared/types";
import { getFields } from "./formData";

interface CustomSubscriptionFormProps {
  isSubmitting?: boolean;
  error?: string | boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  apiError?: IAPIError | null;
  handleSubmit: (subscription: ICustomSubscriptionParams) => void;
}

export const CustomSubscriptionForm: React.FC<CustomSubscriptionFormProps> = ({
  buttons,
  handleSubmit,
  error,
  defaultValues,
  ...rest
}) => {
  return (
    <FormBuilder
      fields={getFields()}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
      submitMode="isDirty"
      apiErrorMessage={error}
      buttons={buttons}
      resetForm={false}
      {...rest}
    />
  );
};
